import { useQuery } from "@tanstack/react-query";
import { ListPartnerState, PagedItemsResponseOfPartnerModel } from "api/client.generated";
import useApi from "./useApi";

interface UseListPartnersReturn {
  partnersResult: PagedItemsResponseOfPartnerModel | undefined;
  isPartnersResultFetching: boolean;
}

const useListPartnersPaged = (
  search: string,
  pageNumber: number, // zero-based page index
  itemsPerPage: number,
): UseListPartnersReturn => {
  const { partnersClient } = useApi();

  const loadData = async (): Promise<PagedItemsResponseOfPartnerModel | undefined> => {
    const response = await partnersClient.listPartners(
      search,
      ListPartnerState.Active,
      null,
      pageNumber * itemsPerPage,
      itemsPerPage,
    );
    return response;
  };

  const { data: partnersResult, isFetching: isPartnersResultFetching } = useQuery({
    queryKey: ["listPartners", search, pageNumber, itemsPerPage],
    queryFn: loadData,
  });

  return { partnersResult, isPartnersResultFetching };
};

export default useListPartnersPaged;
